import React from 'react';
import { ExamApplicationStatus, ExamStatus } from '../../../api/ApiClient';
import { DocumentUpLoader, ApplicantDocuments } from 'components';
import { Dispatch, IRootState } from '../../../redux/store/configureStore';
import { connect } from 'react-redux';

const DocsTabContainer = ({
    examApplication,
    documentTemplateGroups = [],
    uploadExamApplicationDocument,
    submitExamApplication,
    onSuccessSubmit,
    deleteExamApplicationDocumentSource,
    deleteExamApplicationDocument,
    getDocumentTemplateGroups,
    apiError,
    onBackClick,
}: Props) => {
    const onlyWatch = !examApplication || examApplication.exam.status !== ExamStatus.IsApplying;
    const uploadedDocuments = examApplication ? examApplication.documents : [];

    React.useEffect(() => {
        const fetch = async () => {
            if (examApplication && !documentTemplateGroups) {
                await getDocumentTemplateGroups(examApplication.exam.qualificationId);
            }
        };

        fetch();
    }, [examApplication]);

    const submit = async () => {
        if (examApplication) {
            const res = await submitExamApplication(examApplication.examApplicationId);

            if (res) {
                onSuccessSubmit();
            }
        }
    };

    const uploadDocument = (templateId: string, file: File) => {
        if (examApplication) {
            uploadExamApplicationDocument({
                examApplicationId: examApplication.examApplicationId,
                templateId,
                file,
            });
        }
    };

    const deleteDocumentSource = (documentId: string, sourceFileId: string) => {
        if (examApplication) {
            deleteExamApplicationDocumentSource({
                examApplicationId: examApplication.examApplicationId,
                documentId,
                sourceFileId,
            });
        }
    };

    const deleteDocument = (documentId: string) => {
        if (examApplication) {
            deleteExamApplicationDocument({
                examApplicationId: examApplication.examApplicationId,
                documentId,
            });
        }
    };

    if (onlyWatch) {
        return <ApplicantDocuments documents={uploadedDocuments} withoutPadding />;
    }

    return (
        <DocumentUpLoader
          documentTemplateGroups={documentTemplateGroups || []}
          uploadedDocuments={uploadedDocuments}
          deleteDocument={deleteDocument}
          uploadDocument={uploadDocument}
          deleteDocumentSource={deleteDocumentSource}
          submitButtonText="Утвердить заявку"
          onSubmit={submit}
          apiError={apiError}
          onGoBack={onBackClick}
          correctionsRequired={examApplication ? examApplication.status === ExamApplicationStatus.CorrectionsRequired : false}
          withoutPadding
        />
    );
};

const mapState = (state: IRootState) => ({
    examApplication: state.examApplications.applicationDetails,
    documentTemplateGroups: state.examApplications.documentTemplateGroups,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getDocumentTemplateGroups: dispatch.examApplications.getDocumentTemplateGroupsAsync,
    uploadExamApplicationDocument: dispatch.examApplications.uploadExamApplicationDocument,
    deleteExamApplicationDocument: dispatch.examApplications.deleteExamApplicationDocument,
    deleteExamApplicationDocumentSource: dispatch.examApplications.deleteExamApplicationDocumentSourceAsync,
    submitExamApplication: dispatch.examApplications.submitExamApplication,
});

export default connect(mapState, mapDispatch)(DocsTabContainer);

interface IProps {
    onSuccessSubmit: () => void;
    onBackClick: () => void;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps & IProps;
